(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pe-personalization-editor"] && !Shopify.designMode) return;
  try {
    (() => {
  const dialog = document.getElementById('pe-personalization');
  if (!dialog) return;

  const form = dialog.querySelector('form');
  const fields = dialog.querySelector('[data-pe-fields]');
  const status = dialog.querySelector('[data-pe-status]');
  const save = dialog.querySelector('[data-pe-save]');
  const cancel = dialog.querySelector('[data-pe-cancel]');

  const root = window.Shopify?.routes?.root || '/';

  let original;
  let trigger;
  let busy = false;
  let request = 0;

  const editable = ([key, value]) =>
    !key.startsWith('_') &&
    key !== 'MANUAL REVIEW REQUIRED' &&
    typeof value === 'string' &&
    !/(^|[ _-])(id|url|preview|artwork|svg|json|image|file|design)([ _-]|$)/i.test(key) &&
    !/^(https?:|data:|\/\/|\{|\[)/i.test(value.trim());

  async function cart() {
    const response = await fetch(root + 'cart.js', {
      cache: 'no-store',
      headers: { Accept: 'application/json' }
    });

    if (!response.ok) throw new Error(dialog.dataset.error);

    return response.json();
  }

  function close() {
    if (!busy) dialog.close();
  }

  cancel.addEventListener('click', close);

  dialog.addEventListener('cancel', event => {
    if (busy) event.preventDefault();
  });

  dialog.addEventListener('close', () => {
    document.body.classList.remove('pe-personalization-open');

    request++;

    const drawer = trigger?.closest('cart-drawer');

    if (drawer && typeof window.trapFocus === 'function') {
      window.trapFocus(drawer, trigger);
    } else {
      trigger?.focus();
    }
  });

  form.addEventListener('change', event => {
    event.stopPropagation();
  });

  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-pe-edit]');
    if (!button || dialog.open) return;

    event.preventDefault();

    trigger = button;

    const activeRequest = ++request;

    original = null;
    fields.replaceChildren();
    save.disabled = true;
    status.textContent = dialog.dataset.loading;

    if (typeof window.removeTrapFocus === 'function') {
      window.removeTrapFocus();
    }

    dialog.showModal();
    document.body.classList.add('pe-personalization-open');

    /* Keep focus on the sheet itself so iOS does not open the keyboard
       and does not put the focus ring on the Cancel button. */
    requestAnimationFrame(() => {
      dialog.focus({ preventScroll: true });
    });

    try {
      const current = await cart();

      if (!dialog.open || activeRequest !== request) return;

      original = current.items.find(
        item => item.key === button.dataset.peEdit
      );

      if (!original) {
        throw new Error(dialog.dataset.stale);
      }

      let rules;

      try {
        rules = JSON.parse(button.dataset.peRules);

        if (typeof rules === 'string') {
          rules = JSON.parse(rules);
        }
      } catch (_) {}

      if (!Array.isArray(rules)) {
        rules = [];
      }

      const entries = Object.entries(
        original.properties || {}
      ).filter(editable);

      if (!entries.length) {
        throw new Error(dialog.dataset.empty);
      }

      entries.forEach(([name, value], index) => {
        const rule = rules.find(
          field =>
            field.name === name ||
            field.name?.replace(/ /g, '_') === name
        );

        const input = document.createElement(
          rule?.type === 'dropdown' ? 'select' : 'input'
        );

        input.id = 'pe-field-' + index;
        input.dataset.property = name;

        if (input.tagName === 'SELECT') {
          const values = String(rule.value || '').split(',');

          if (!values.includes(value)) {
            values.unshift(value);
          }

          values.forEach(option => {
            input.add(new Option(option, option));
          });
        } else {
          input.type = 'text';

          if (Number(rule?.length) > 0) {
            input.maxLength = Number(rule.length);
          }

          if (rule?.pattern) {
            input.pattern = rule.pattern;
          }

          if (rule?.pattern_message) {
            input.title = rule.pattern_message;
          }
        }

        input.required = rule?.required === true;
        input.value = value;

        const label = document.createElement('label');
        label.htmlFor = input.id;
        label.textContent = name.replace(/_/g, ' ');

        fields.append(label, input);
      });

      status.textContent = '';
      save.disabled = false;
    } catch (error) {
      if (activeRequest === request) {
        status.textContent =
          error.message || dialog.dataset.error;
      }
    }
  });

  form.addEventListener('submit', async event => {
    event.preventDefault();
    event.stopPropagation();

    if (
      busy ||
      !original ||
      save.disabled ||
      !form.reportValidity()
    ) {
      return;
    }

    const properties = Object.fromEntries(
      Array.from(
        fields.querySelectorAll('[data-property]'),
        input => [input.dataset.property, input.value]
      )
    );

    if (
      Object.entries(properties).every(
        ([name, value]) => value === original.properties[name]
      )
    ) {
      close();
      return;
    }

    busy = true;
    save.disabled = true;
    cancel.disabled = true;
    status.textContent = dialog.dataset.loading;

    let sent = false;

    try {
      const current = await cart();

      const item = current.items.find(
        line => line.key === original.key
      );

      if (!item) {
        throw new Error(dialog.dataset.stale);
      }

      properties._customer_edited = 'true';
      properties._edited_at = new Date().toISOString();

      sent = true;

      const response = await fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          id: item.key,
          quantity: item.quantity,
          properties
        })
      });

      const updated = await response.json();

      if (!response.ok) {
        sent = false;

        throw new Error(
          typeof updated.description === 'string'
            ? updated.description
            : dialog.dataset.error
        );
      }

      const confirmed = updated.items?.some(
        line =>
          line.variant_id === item.variant_id &&
          Object.entries(properties).every(
            ([key, value]) => line.properties?.[key] === value
          )
      );

      if (!confirmed) {
        throw new Error(dialog.dataset.uncertain);
      }

      window.location.assign(dialog.dataset.cartUrl);
    } catch (error) {
      status.textContent = sent
        ? dialog.dataset.uncertain
        : error.message || dialog.dataset.error;

      save.disabled = sent;
      busy = false;
      cancel.disabled = false;
    }
  });
})();
  } catch(e) { console.error(e); }
})();

})();
